import React from 'react';
const stats = [{
  value: '+500',
  label: 'Artesanos confían'
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function Stats() {
  return <section aria-label="Resultados reales" className="border-y border-white/5 bg-ink-2" data-id="element-146" data-mp="2ixpb6q22oyzs">
      <div className="mx-auto max-w-5xl px-5" data-id="element-147" data-mp="2nvh15ej5qb1c">
        <dl className="grid grid-cols-2 gap-6 pt-[18px] pb-[7px] sm:grid-cols-4" data-id="element-148" data-mp="298e6dfm7yghp">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-149" data-mp="2dzdym7ke8adv">
              <dt className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-150" data-mp="2e0yxg9dqqfhj">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-151" data-mp="205d1tjd04xg5">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}